import TodoDailyCDataFunc from "@/pcomponents/common/content/todo/todo_dailyc/data";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';

function TodoDailyCArea(props: any) {
  let myProps = {
    stu_info: null,
    set_stu_info: (inData: any) => { },
    subject_name: "",
    select_date: "",
    callback_refresh: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let stu_info = myProps.stu_info;
  let subject_name = myProps.subject_name;
  let select_date = myProps.select_date;
  let todo_dailyc_info = TodoDailyCDataFunc.get_info_of_arr({
    stu_seq: stu_info["a_seq"],
    select_date: select_date,
    subject_name: subject_name,
    todo_dailyc_arr: stu_info.todo_dailyc_arr,
  });
  let sort_select_arr = TodoDailyCDataFunc.sort_select_arr;

  const on_change_dailyc_input = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    let name = opt_obj.target.name;
    let value = opt_obj.target.value;
    let change_todo_dailyc_info: any = {
      ...todo_dailyc_info,
    };
    change_todo_dailyc_info[name] = value;

    let change_stu_info = { ...stu_info };

    let is_exist_pre = false;
    if (stu_info.todo_dailyc_arr) {
      for (let i = 0; i < stu_info.todo_dailyc_arr.length; i++) {
        let tmp_todoc = stu_info.todo_dailyc_arr[i];
        if (tmp_todoc.a_stu_seq == change_todo_dailyc_info.a_stu_seq
          && tmp_todoc.a_date == change_todo_dailyc_info.a_date
          && tmp_todoc.a_subject == change_todo_dailyc_info.a_subject) {
          change_stu_info.todo_dailyc_arr[i] = change_todo_dailyc_info;
          is_exist_pre = true;
          break;
        }
      }
    } else {
      change_stu_info.todo_dailyc_arr = [];
    }

    if (is_exist_pre == false) {
      change_todo_dailyc_info["a_date"] = select_date;
      change_todo_dailyc_info["a_subject"] = subject_name;
      change_todo_dailyc_info["a_stu_seq"] = stu_info.a_seq;
      change_stu_info.todo_dailyc_arr.push(change_todo_dailyc_info);
    }

    myProps.set_stu_info(change_stu_info);
  };

  const go_todo_dailyc_write = (inData: any) => {
    alert("여기서 완료 처리 할 수 없습니다.");
    return false;
    let opt_obj = {
      todo_dailyc_sort: "complete",
      a_memo: "",
      confirm_msg: "완료",
      ...inData
    };

    if (strFunc.is_empty(select_date)) {
      alert("날짜를 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(subject_name)) {
      alert("과목을 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.todo_dailyc_sort)) {
      alert("구분을 선택하세요.");
      return false;
    }
    if (!confirm(opt_obj.confirm_msg + " 하시겠습니까?")) {
      return false;
    }

    let todo_dailyc_data = {
      a_date: select_date,
      a_subject: subject_name,
      a_stu_seq: "",
      a_sort: opt_obj.todo_dailyc_sort,
      a_memo: opt_obj.a_memo,
      a_writer_seq: user.user_seq,
      a_writer: user.user_name,
    };

    let write_todo_dailyc_arr: any = [];

    let todo_dailyc_data_obj = {
      ...todo_dailyc_data,
      a_stu_seq: stu_info.a_seq,
      a_stu_name: stu_info.a_user_name,
      a_writer_seq: user.user_seq,
      a_writer: user.user_name,
    };
    write_todo_dailyc_arr.push(todo_dailyc_data_obj);

    let form_json_data = {
      "data_arr": write_todo_dailyc_arr,
      "is_default_val": "1",
      "is_auto_add_star": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(opt_obj.confirm_msg + " 되었습니다.");
          myProps.callback_refresh({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  let btn_wrap_style: any = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "5px",
    marginTop: "5px"
  };
  let btn_style: any = {
    lineHeight: "30px",
    textAlign: "center",
    background: "#888",
    color: "#fff",
    minWidth: "50px",
    padding: "0px 4px",
    borderRadius: "8px",
  };

  const get_sort_btn_tags = () => {
    let tags = sort_select_arr.map((item: any, idx: number) => {
      let row_btn_style: any = { ...btn_style };

      if (todo_dailyc_info.a_sort == item.value) {
        row_btn_style["background"] = "#2e5251";
        row_btn_style["color"] = "#fff";
      }
      return (
        <button key={idx} style={row_btn_style}
          onClick={() => {
            go_todo_dailyc_write({
              todo_dailyc_sort: item.value,
              a_memo: todo_dailyc_info.a_memo,
            });
          }}>
          {item.text}
        </button>
      );
    });
    return tags;
  };

  return (
    <div style={{ position: "relative", width: "95%", margin: "0 auto" }}>
      <div style={{ padding: "12px", borderRadius: "10px", background: "#efefef" }}>
        <div className="text-center">완료처리</div>
        <div style={btn_wrap_style} >
          {get_sort_btn_tags()}
        </div>
        <div className="mt-1" title={todo_dailyc_info.a_memo} style={{ minHeight: "20px" }}>
          <table style={{ width: "100%" }}>
            <colgroup>
              <col width={"99%"}></col>
              <col width={"1%"}></col>
            </colgroup>
            <tbody>
              <tr>
                <td>
                  {/* <TextAreaComponent
                    name="a_memo"
                    value={todo_dailyc_info.a_memo}
                    onChange={(e: any) => {
                      on_change_dailyc_input(e);
                    }}
                    placeholder="완료처리 사유"
                    style={{ color: "#888", background: "transparent", border: "1px solid #ddd", borderRadius: "5px" }}
                  ></TextAreaComponent> */}
                  <div className="my_flex_center">
                    <span>사유</span>
                    <div style={{flex:"grow",display:"inline-block",minHeight:"30px",border:"1px solid #ccc",borderRadius:"5px",width:"85%"}}>
                      <MultyLineTextView
                        text={todo_dailyc_info.a_memo}
                      ></MultyLineTextView>
                    </div>
                  </div>
                </td>
                <td className="text-right">
                  {/* 
                  <button className="btn-s btn-dark"
                    onClick={()=>{
                      go_todo_dailyc_write({
                        todo_dailyc_sort: todo_dailyc_info.a_sort,
                        a_memo: todo_dailyc_info.a_memo,
                        confirm_msg: "저장",
                      });
                    }}>저장</button>
                     */}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default TodoDailyCArea;